import type { DateIso } from '../../../types/domain';
import { addDays, dateFromIso, isoStr, isWE } from '../base';
import { getHolidaysCached } from '../holidays';

// Nombre de jours ouvrés (hors WE et jours fériés) entre deux dates ISO incluses.
export function workingDaysInPeriod(
  startIso: DateIso | null | undefined,
  endIso: DateIso | null | undefined,
): number {
  if (!startIso || !endIso) return 0;
  let c = 0;
  let cur = dateFromIso(startIso);
  const end = dateFromIso(endIso);
  while (cur <= end) {
    const iso = isoStr(cur);
    if (!isWE(cur) && !getHolidaysCached(cur.getFullYear()).has(iso)) c++;
    cur = addDays(cur, 1);
  }
  return c;
}
